import { useCallback, useEffect, useState } from 'react';

import testimonials from '@/pages/Home/utils/testimonials.js';
import { Trans } from 'react-i18next';
import TestimonialCard from '@/pages/Home/components/TestimonialCard.jsx';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const getCardsToShow = (width) => {
  if (width >= 1280) {
    return 3;
  } else if (width >= 1024) {
    return 2;
  } else if (width >= 768) {
    return 2;
  } else {
    return 1;
  }
};
const HomePageTestimonials = () => {
  // const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleNext = useCallback(() => {
    const showCount = getCardsToShow(windowWidth);
    if (currentIndex >= testimonials.length - showCount) {
      setCurrentIndex(0);
    } else {
      setCurrentIndex((prevIndex) => Math.min(testimonials.length - showCount, prevIndex + showCount));
    }
  }, [currentIndex, windowWidth]);

  const handlePrev = useCallback(() => {
    const showCount = getCardsToShow(windowWidth);
    if (currentIndex === 0) {
      setCurrentIndex(Math.max(0, testimonials.length - showCount));
    } else {
      setCurrentIndex((prevIndex) => Math.max(0, prevIndex - showCount));
    }
  }, [currentIndex, windowWidth]);

  useEffect(() => {
    const handleResize = () => {
      const showCount = getCardsToShow(window.innerWidth);
      const newIndex = Math.min(testimonials.length - showCount, currentIndex);
      setCurrentIndex(newIndex >= 0 ? newIndex : 0);
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [currentIndex, windowWidth]);

  useEffect(() => {
    const interval = setInterval(handleNext, 6000);
    return () => clearInterval(interval);
  }, [handleNext, currentIndex]);

  const showCount = getCardsToShow(windowWidth);
  const testimonialSlice = [...testimonials.slice(currentIndex, currentIndex + showCount)];

  return (
    <section className='flex flex-col justify-center pb-8 pt-8'>
      <h3 className='mb-3 text-center text-3xl font-bold text-[#1B1310] md:text-4xl'>
        <Trans i18nKey='testimonials.title' />
      </h3>
      <div className='mx-auto mb-9 h-1.5 w-[280px] bg-primary-yellow md:mb-10 md:w-[330px]'></div>
      <div className='relative mx-auto drop-shadow-[0_1px_2px_rgba(0,0,0,0.25)]'>
        <div className='flex overflow-x-hidden'>
          <div className='flex cursor-pointer items-center justify-start px-4' onClick={() => handlePrev()}>
            <FaChevronLeft color={'#FDD400'} size={30} />
          </div>
          <div className={`flex gap-3`}>
            {testimonialSlice.map((testimonial) => (
              <TestimonialCard key={testimonial.id + testimonial.name} testimonial={testimonial} />
            ))}
          </div>
          <div className='flex cursor-pointer items-center justify-start px-4' onClick={() => handleNext()}>
            <FaChevronRight color={'#FDD400'} size={30} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomePageTestimonials;
